module.exports = __webpack_public_path__ + "img/vue2-milieu_rose.91a92401.png";